import request from "@/utils/request";

export function getEventInfo(eventCode) {
    return request({
        url: "/event/getEvent",
        method: "get",
        params: {
            eventCode
        }
    });
}

export function getEventInfo2(obj) {
    return request({
        url: "/event/getEvent",
        method: "get",
        params: {
            channel: obj.channel,
            eventCode: obj.eventCode,
        }
    });
}


// WEBPACK FOOTER //
// ./src/api/event.js